export const load = () => ({
	h1: 'Soundproof Your Home: Window Inserts & The Basics',
	title: 'Soundproof Your Home with Indow Window Inserts',
	description:
		"Soundproofing windows doesn't have to be difficult or costly. Read about how you can eliminate noise with easy soundproof solutions.",
	showTitle: true,
});
